import axios from '@/plugins/axios'
import { successResponse, errorResponse } from '@/plugins/axios/utils'
import webStorage from '../../../store/webStorage/helper'

const serverURL = process.env.BACKEND_URL

const baseURL = `${serverURL}/v2/tourringhistory`

const eventURL = `${serverURL}/v2/trEvent`

export function getRoomStatus (roomId) {
  return axios.get(`${baseURL}/room/${roomId}`)
    .then(res => successResponse(res.data))
    .catch(err => errorResponse(err))
}

export function startRoom (roomId) {
  return axios.patch(`${baseURL}/room`, { roomId }, {
    headers: {
      'istaging-token-type': 'istaging',
      'istaging-token': webStorage.getItem(`session-token-${process.env.NODE_ENV}`)
    }
  })
    .then(res => successResponse(res.data))
    .catch(err => errorResponse(err))
}

export function postRoomHostLeave (roomId) {
  return axios.post(`${eventURL}`, {
    eventType: 102,
    payload: {
      channelName: roomId
    }
  })
    .then(res => successResponse(res.data))
    .catch(err => errorResponse(err))
}
